// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2iIsM","modalForm":"UpgradeEpcsModal_modalForm__-ckFD","modalFooter":"UpgradeEpcsModal_modalFooter__3CBgC"};